"use client";
import React from "react";
import styles from "./ServerSupportShowcaseSection.module.css";
import { serverSupportShowcaseData } from "@/app/services/data/server-support";

const ServerSupportShowcaseSection = () => {
  return (
    <section className={styles.section} aria-label="Server support highlights">
      {serverSupportShowcaseData.map((item, idx) => {
        const isEven = idx % 2 === 1;
        return (
          <div
            key={idx}
            className={`${styles.block} ${isEven ? styles.rowReverse : ""}`}
          >
            {/* Content side */}
            <div
              className={`${styles.side} ${styles.contentSide} ${
                item.theme === "accent" ? styles.accent : ""
              }`}
            >
              <div className={styles.contentInner}>
                {item.eyebrow && (
                  <span className={styles.eyebrow}>{item.eyebrow}</span>
                )}
                <h3 className={styles.title}>{item.title}</h3>
                <p className={styles.description}>{item.description}</p>
              </div>
            </div>
            {/* Image side */}
            <div
              className={`${styles.side} ${styles.imageSide}`}
              style={{ backgroundImage: `url("${item.image}")` }}
              aria-label={item.eyebrow || "Server support visual"}
              role="img"
            >
              <div className={styles.imageOverlay} />
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default ServerSupportShowcaseSection;
